import React from 'lib/react';
import { EVGrid } from 'lib/components';
import OrderStyles from 'features/order/OrderStyles';
import { useTranslation } from 'lib/translation';
import WarningBanner from '../../WarningBanner/WarningBanner.component';

function SRSValidationBannerComponent() {
  const classes = OrderStyles();
  const { t } = useTranslation();

  return (
    <EVGrid className={classes.srsContainer}>
      <WarningBanner body={t('order__report_srs_validation_banner')} />
    </EVGrid>
  );
}

export default SRSValidationBannerComponent;
